import { IntegrationClientKind } from '@/types/schema';

import {
  AssetIntegrationProviders,
  getIntegrationProviderDisplayName,
} from './shared/constants';

export function getProviderFromIntegrationClientKind(
  kind: IntegrationClientKind
): AssetIntegrationProviders {
  switch (kind) {
    case IntegrationClientKind.Addepar:
      return AssetIntegrationProviders.ADDEPAR;
    case IntegrationClientKind.Orion:
      return AssetIntegrationProviders.ORION;
    case IntegrationClientKind.BlackDiamond:
      return AssetIntegrationProviders.BLACK_DIAMOND;
    case IntegrationClientKind.Emoney:
      return AssetIntegrationProviders.EMONEY;
    case IntegrationClientKind.Snowflake:
      return AssetIntegrationProviders.SNOWFLAKE;
    default:
      throw new Error(`Unsupported integration client kind: ${kind}`);
  }
}

export function getKindFromProvider(
  provider: AssetIntegrationProviders
): IntegrationClientKind {
  switch (provider) {
    case AssetIntegrationProviders.ADDEPAR:
      return IntegrationClientKind.Addepar;
    case AssetIntegrationProviders.ORION:
      return IntegrationClientKind.Orion;
    case AssetIntegrationProviders.BLACK_DIAMOND:
      return IntegrationClientKind.BlackDiamond;
    case AssetIntegrationProviders.EMONEY:
      return IntegrationClientKind.Emoney;
    case AssetIntegrationProviders.SNOWFLAKE:
      return IntegrationClientKind.Snowflake;
    default:
      throw new Error(`Unsupported provider: ${provider}`);
  }
}

export function getProviderDisplayNameFromIntegrationClientKind(
  kind: IntegrationClientKind
): string {
  switch (kind) {
    case IntegrationClientKind.Addepar:
    case IntegrationClientKind.Orion:
    case IntegrationClientKind.BlackDiamond:
    case IntegrationClientKind.Emoney:
    case IntegrationClientKind.Snowflake:
      return getIntegrationProviderDisplayName(
        getProviderFromIntegrationClientKind(kind)
      );
    default:
      return 'Unknown';
  }
}
